import { defineMessages } from 'react-intl-next';

export const nonContextualNoteMessages: {
    confluenceValueProp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; jiraValueProp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; jpdValueProp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; loomValueProp: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	jpdValueProp: {
		id: 'cross-join-nudges.non-contextual-note.jpd-value-prop',
		defaultMessage:
			'{requestingUser} needs Jira Product Discovery access to prioritize ideas and create roadmaps.',
		description:
			'Message displayed to the admin. Explains the value proposition for granting Jira Product Discovery access. The {requestingUser} placeholder will be replaced with the name of the user requesting access. The message informs admins of the purpose and benefits of the product.',
	},
	jiraValueProp: {
		id: 'cross-join-nudges.non-contextual-note.jira-value-prop',
		defaultMessage: '{requestingUser} needs Jira access to plan and track work.',
		description:
			'Message displayed to the admin. Explains the value proposition for granting Jira access. The {requestingUser} placeholder will be replaced with the name of the user requesting access. The message informs admins of the purpose and benefits of Jira.',
	},
	loomValueProp: {
		id: 'cross-join-nudges.non-contextual-note.loom-value-prop',
		defaultMessage: '{requestingUser} needs Loom access to create and edit videos.',
		description:
			'Message displayed to the admin. Explains the value proposition for granting Loom access. The {requestingUser} placeholder will be replaced with the name of the user requesting access. The message informs admins of the purpose and benefits of Loom.',
	},
	confluenceValueProp: {
		id: 'cross-join-nudges.non-contextual-note.confluence-value-prop',
		defaultMessage:
			'{requestingUser} needs Confluence access to collaborate on pages and whiteboards.',
		description:
			'Message displayed to the admin. Explains the value proposition for granting Confluence access. The {requestingUser} placeholder will be replaced with the name of the user requesting access. The message informs admins of the purpose and benefits of Confluence.',
	},
});
